import { ChevronDown20Regular, ChevronLeft20Regular, ChevronRight20Regular, } from '@fluentui/react-icons';
import { getKey, isEnterOrSpace, KeyboardKey, } from '@office-start/keystroke-handler-utility';
import React, { useCallback, useMemo } from 'react';
import { useCarouselHeaderCollapsibleStyles } from './CarouselHeaderCollapsible.styles';
import { CarouselHeaderType } from './model';
var CarouselHeaderCollapsible = function (_a) {
    var title = _a.title, titleClassNames = _a.titleClassNames, headerType = _a.headerType, options = _a.options;
    var styles = useCarouselHeaderCollapsibleStyles();
    // Collapsible header with chevron collapse/expand
    var headerResources = options.headerResources, isCollapsed = options.isCollapsed, isRtl = options.isRtl, onCarouselToggled = options.onCarouselToggled;
    var onHeaderKeyDown = useCallback(function (e) {
        if (isEnterOrSpace(e)) {
            e.preventDefault();
            onCarouselToggled(!isCollapsed);
            return;
        }
        // Close on escape
        if (!isCollapsed) {
            var key = getKey(e);
            if (key === KeyboardKey.Escape) {
                e.preventDefault();
                e.stopPropagation();
                onCarouselToggled(!isCollapsed);
            }
        }
    }, [isCollapsed, onCarouselToggled]);
    var onHeaderClick = useCallback(function (_e) {
        onCarouselToggled(!isCollapsed);
    }, [isCollapsed, onCarouselToggled]);
    var ariaLabel = useMemo(function () {
        if (!headerResources) {
            return title;
        }
        if (isCollapsed) {
            return "".concat(title, ". ").concat(headerResources.expandHeaderAriaLabel);
        }
        return "".concat(title, ". ").concat(headerResources.collapseHeaderAriaLabel);
    }, [isCollapsed, headerResources, title]);
    var chevron = useMemo(function () {
        if (!isCollapsed) {
            return React.createElement(ChevronDown20Regular, { className: styles.icon });
        }
        if (isRtl) {
            return React.createElement(ChevronLeft20Regular, { className: styles.icon });
        }
        return React.createElement(ChevronRight20Regular, { className: styles.icon });
    }, [isCollapsed, isRtl, styles.icon]);
    return (React.createElement("div", { onKeyDown: onHeaderKeyDown, onClick: onHeaderClick, "aria-label": ariaLabel, title: title, "aria-expanded": !isCollapsed, tabIndex: 0, role: "button", className: styles.container },
        chevron,
        headerType === CarouselHeaderType.Page ? (React.createElement("h1", { className: titleClassNames }, title)) : (React.createElement("h2", { className: titleClassNames }, title))));
};
CarouselHeaderCollapsible.displayName = 'CarouselHeaderCollapsible';
export default CarouselHeaderCollapsible;
//# sourceMappingURL=CarouselHeaderCollapsible.js.map